import {
    INGRESADO_ID,
    MINORISTAS_ID,
    RECHAZADOS_ID,
    CARMUV_ID,
    NO_ADMITIDOS_ID,
    CONFIRMAR_MINORISTAS,
    CAMBIAR_MINORISTAS,
    CONFIRMAR_RECHAZADOS,
    CAMBIAR_RECHAZADOS,
    CONFIRMAR_CARMUV,
    CAMBIAR_CARMUV,
    FINALIZAR_PROCESO_VENTA,
    FINALIZAR
  } from './constants'

export const orderPossibleActions = (actions, stateId) => {
    const ACTION_MINORISTA = actions.find(({ Action: { action_label } }) => (action_label === CONFIRMAR_MINORISTAS || action_label === CAMBIAR_MINORISTAS))
    const ACTION_RECHAZADOS = actions.find(({ Action: { action_label } }) => (action_label === CONFIRMAR_RECHAZADOS || action_label === CAMBIAR_RECHAZADOS))
    const ACTION_CARMUV = actions.find(({ Action: { action_label } }) => (action_label === CONFIRMAR_CARMUV || action_label === CAMBIAR_CARMUV))
    const ACTION_FINALIZAR = actions.find(({ Action: { action_label } }) => (action_label === FINALIZAR_PROCESO_VENTA || action_label === FINALIZAR))
    const LEFTOVER_ACTIONS = actions.filter( action  => action !== ACTION_MINORISTA && action !== ACTION_RECHAZADOS && action !== ACTION_CARMUV && action !== ACTION_FINALIZAR)
  
    let actionsArray = []
  
    if (stateId === INGRESADO_ID) {
      ACTION_MINORISTA && actionsArray.push(ACTION_MINORISTA)
      ACTION_RECHAZADOS && actionsArray.push(ACTION_RECHAZADOS)
      ACTION_CARMUV && actionsArray.push(ACTION_CARMUV)
    } else if (stateId === MINORISTAS_ID) {
      ACTION_RECHAZADOS && actionsArray.push(ACTION_RECHAZADOS)
      ACTION_CARMUV && actionsArray.push(ACTION_CARMUV)
      ACTION_FINALIZAR && actionsArray.push(ACTION_FINALIZAR)
    } else if (stateId === RECHAZADOS_ID) {
      ACTION_FINALIZAR && actionsArray.push(ACTION_FINALIZAR)
      ACTION_MINORISTA && actionsArray.push(ACTION_MINORISTA)
      ACTION_CARMUV && actionsArray.push(ACTION_CARMUV)
    } else if (CARMUV_ID.includes(stateId)) {
      ACTION_MINORISTA && actionsArray.push(ACTION_MINORISTA)
      ACTION_RECHAZADOS && actionsArray.push(ACTION_RECHAZADOS)
      ACTION_FINALIZAR && actionsArray.push(ACTION_FINALIZAR)
    } else if (stateId === NO_ADMITIDOS_ID) {
      ACTION_CARMUV && actionsArray.push(ACTION_CARMUV)
      ACTION_MINORISTA && actionsArray.push(ACTION_MINORISTA)
      ACTION_RECHAZADOS && actionsArray.push(ACTION_RECHAZADOS)
    }

    actionsArray.push(...LEFTOVER_ACTIONS)

    return actionsArray
}
